import UIDs from "../../../../UIDs";

const uid = UIDs.screens.plain.promotiondetails;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    IS_ATTED_PROMOTION_ASYNC:`${uid}.isAttedPromotionAsync`,
    IS_ATTED_PROMOTION_SUCCESS:`${uid}.isAttedPromotionSuccess`,
    IS_ATTED_PROMOTION_FAILURE:`${uid}.isAttedPromotionFailure`,
    UPDATE_VALUE: `${uid}.updateValue`,
};

export { ActionTypes };